<div class="layout-sidebar">
    <div class="sidebar-navigation"><app-menu></app-menu></div>
    <div class="sidebar-session">
        <button type="button" class="sidebar-logout" (click)="cerrarSesion()">
            <i class="pi pi-sign-out"></i><span>Cerrar sesión</span>
        </button>
    </div>
</div>
